<template>
  <div id="app">
    <div class="gameroom" v-if="isGameRoom">
      <GameRoom v-if="isGameRoom" />
    </div>
    <div class="registration" v-else>
      <Header v-if="!isGameRoom" />
      <div v-if="!isGameRoom" class="wrap" id="wrap">
        <step1-login v-if="login_status" />
        <step1 v-else />
        <step2 />
        <!--<step3/>
        <step4/>-->
      </div>
      <Footer />
      <div class="up" id="up" @click="backToTop">
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="32" cy="32" r="32" fill="white" />
          <path d="M32 44.5775V20" stroke="black" stroke-width="2" />
          <path
            d="M43.2839 31.3137L31.9702 20L20.6565 31.3137"
            stroke="black"
            stroke-width="2"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Step1 from "@/components/steps/step1";
import Step2 from "@/components/steps/step2";
import Step3 from "@/components/steps/step3";
import Step4 from "@/components/steps/step4";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Step1Login from "@/components/steps/step1-login";
import GameRoom from "@/components/gameroom/gameroom";

export default {
  components: { Step1Login, Footer, Header, Step2, Step1, GameRoom },
  computed: {
    login_status() {
      return this.$store.getters.login_status;
    },
    isGameRoom() {
      var isGameRoom = this.$route.name === "GameRoom";
      if (isGameRoom) {
        this.$store.dispatch("cleanSignupSteps");
      }
      return isGameRoom;
    },
  },
  mounted() {
    this.$store.dispatch("checkUser");

    let wrap = document.getElementById("wrap");

    let padding = parseInt(window.getComputedStyle(wrap).paddingRight, 10) / 2;
    let left = wrap.offsetLeft;
    let width = wrap.offsetWidth;
    document.getElementById("up").style.left =
      left + width - padding - 32 + "px";

    window.onresize = function (event) {
      let padding =
        parseInt(window.getComputedStyle(wrap).paddingRight, 10) / 2;
      let left = wrap.offsetLeft;
      let width = wrap.offsetWidth;
      document.getElementById("up").style.left =
        left + width - padding - 32 + "px";
    };

    window.addEventListener("scroll", function () {
      let scroll = window.pageYOffset;
      if (scroll !== 0) {
        document.getElementById("up").style.visibility = "visible";
        document.getElementById("up").style.opacity = 1;
      } else {
        document.getElementById("up").style.visibility = "hidden";
        document.getElementById("up").style.opacity = 0;
      }
    });
  },
  methods: {
    backToTop() {
      if (window.pageYOffset > 0) {
        window.scrollBy(0, -30);
        setTimeout(this.backToTop, 0);
      }
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap");

.component-fade-enter-active,
.component-fade-leave-active {
  transition: all 1s ease;
}
.component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active до версии 2.1.8 */ {
  height: 77px;
}

.gameroom {
  background: transparent;
  font-family: "Blinker", "Roboto", sans-serif;
  font-size: 20px !important;
}

html {
  background: linear-gradient(to top, rgb(0, 0, 0), rgb(72, 72, 72));
  font-family: "Blinker", "Roboto", sans-serif;
  font-size: 20px !important;
}

body {
  margin: 0;
}

button {
  outline: none;

  position: relative;
}

.wrap {
  max-width: 1440px;

  margin: 0 auto;
  padding: 0 10.4rem;
}

.up {
  height: 64px;
  width: 64px;

  border-radius: 50%;

  overflow: hidden;

  cursor: pointer;

  visibility: hidden;

  position: fixed;
  top: 50%;
  transform: translate(0, -50%);

  transition: opacity 0.1s linear, visibility 0.1s linear;
}

.up:hover {
  opacity: 0.5;
}

/*-------------------Loading-------------------*/
.lds-ring {
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 2rem;
  transform: translate(1rem, -50%);
  width: 0.75rem;
  height: 0.75rem;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 0.75rem;
  height: 0.75rem;
  margin: 0;
  border: 1px solid #000;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*-------------------Vuetify-------------------*/
.v-text-field {
  padding-top: 0 !important;
}

.v-text-field__slot input {
  font-size: 1rem !important;
  line-height: 1rem !important;

  padding: 0.4rem 0 !important;
}

.theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
  border-image: none !important;
}

.v-text-field__details {
  display: none !important;
}

.v-input--radio-group {
  margin-top: 0 !important;
}

.v-input--selection-controls__ripple {
  display: none !important;
}

.v-input--selection-controls__input {
  width: 12px !important;
  height: 10px !important;
}

.v-input--selection-controls__input .v-icon,
.v-icon__svg,
.v-input--selection-controls__input input[role="radio"] {
  width: 12px !important;
  height: 12px !important;
}

.theme--light.v-label {
  color: #000 !important;
  font-size: 1rem;

  margin-left: 5px;
}

/*-----------------------------------------Step-----------------------------------------*/
.step {
  padding: 3rem;
  margin-bottom: 3rem;

  border-radius: 10px;
}

.step__preview {
  display: flex;
  justify-content: space-between;
}

.step__preview-title {
  text-align: center;

  width: 80%;
}

.step__name {
  font-size: 2rem;
}

.step__preview-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/*-------------------Step Active-------------------*/
.status-active {
  background-color: #fff;
}

/*-------------------Step Success-------------------*/
.status-success {
  border: 1px solid #ffd500;
}

.status-success .step__name {
  color: #fff;
}

/*-------------------Step Empty-------------------*/
.status-empty {
  border: 1px solid rgba(255, 255, 255, 0.6);

  cursor: pointer;

  transition: background-color 0.1s linear;
}

.status-empty:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.status-empty .step__name {
  color: rgba(255, 255, 255, 0.6);
}

/*-------------------Step Empty-------------------*/
.status-unavailable {
  border: 1px solid #404040;
}

.status-unavailable .step__name,
.status-unavailable .step__subname {
  color: #404040;
}

.status-unavailable .step__preview-icon {
  display: none;
}

.status-unavailable .step__preview {
  justify-content: center;
}

/*-------------------Step Repeat-------------------*/
.status-success-repeat {
  border: 1px solid #ffd500;

  cursor: pointer;
}

.status-success-repeat:hover {
  background-color: rgba(255, 213, 0, 0.3);
}

.step__preview-repeat .step__name {
  color: #ffd500;
}

.step__subname {
  color: #a6a6a6;
  font-size: 1.2rem;
}

/*-----------------------------------------Step Form-----------------------------------------*/
.step__form {
  padding: 0 4.5rem;

  overflow: hidden;
}
.step__form-title {
  font-size: 2rem;

  text-align: center;
}

.step__form-subtitle {
  font-size: 1.2rem;
  text-align: center;

  margin-bottom: 3rem;

  opacity: 0.6;
}

.step__form-label {
  margin-top: 0.8rem;
}

.step__form-label.checkbox_step_1 {
  color: rgba(0, 0, 0, 0.5);
}

.step__form-label_disabled {
  color: rgb(128, 128, 128);
}

.step__form-input-error {
  color: #ff3d00;
  font-size: 0.7rem;
}

.step__form-os-wrap {
  margin-bottom: 2rem;
}

.step__form-different-id {
  margin-bottom: 0.5rem;
}

.step__form-invite-form {
  display: flex;
  justify-content: space-between;

  margin-top: 1.75rem;
}

.step__form-invite-form-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.step__form-invite-form-input {
  padding-top: 0.3rem;
}

.step__form-invite-form-input .v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.step__form-invite-form-input .v-input__slot {
  margin: 0 !important;
}

.step__form-invite-form-input input {
  text-align: center !important;

  width: 6.25rem !important;
}

.step__form-invite-form-input .v-text-field__details {
  display: none;
}

.step__form-invite-form-copy-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.step__form-invite-form-copy-button button {
  width: 7.5rem;
  height: 2.5rem;

  background-color: #000;

  border-radius: 10px;

  color: #fff;
}

.step__form-skip-button-wrap {
  margin-top: 0.5rem;

  text-align: center;
}

.step__form-with-button_adaptive {
  display: none;
}

.step__form-skip-button-wrap a {
  color: #000;

  font-size: 0.7rem;

  cursor: pointer;

  text-decoration: underline;
}

.step__form-emails {
  margin-top: 1rem;
  padding-right: 1rem;

  height: 7.2rem;

  overflow-y: scroll;
}

.step__form-emails::-webkit-scrollbar {
  width: 2px;
  background-color: #ececec;
}

.step__form-emails::-webkit-scrollbar-thumb {
  background-color: #000;
}

.step__form-emails::-webkit-scrollbar-thumb:hover {
  background-color: #253861;
}

.step__form-emails::-webkit-scrollbar-button:vertical:start:decrement,
.step__form-emails::-webkit-scrollbar-button:vertical:end:increment {
  display: none;
}

.step__form-error {
  color: #ff3d00;
  font-size: 0.7rem;
  text-align: center;

  margin-bottom: 1rem;
}

.step__form-button-wrap {
  margin-top: 3.25rem;
}

.step__form-button {
  font-size: 1.1rem;
  color: #000;

  padding: 1rem 2rem;

  border-radius: 10px;
  border: none;

  left: 50%;
  transform: translate(-50%, 0);

  background-color: #ffd500;

  cursor: pointer;

  transition: background-color 0.1s linear;
}

.step__form-button:active {
  background-color: #ba9b00;
}

.step__form-button-loading {
  background-color: #ba9b00;
}

/*Step3*/
.step__form-with-button {
  display: grid;
  grid-template-columns: 3fr 1fr;

  margin-bottom: 1rem;
}

.step__form-with-button_disabled .step__form-label,
.step__form-with-button_disabled .v-input--is-label-active,
.step__form-button_disable {
  opacity: 0.5;
}

.step__form-with-button-left {
  width: 90%;
}

.step__form-with-button-left-tooltip-wrap {
  display: grid;
  grid-template-columns: 1fr auto;
}

.step__form-with-button-left-tooltip {
  width: 43px;
  height: 43px;

  margin-left: 1rem;

  background-color: #ffd500;

  text-align: center;
  font-size: 0.5rem;
  line-height: 43px;
  font-weight: 700;

  border-radius: 50%;

  cursor: pointer;

  overflow: hidden;
}

.step__form-with-button-left-tooltip_hidden {
  visibility: hidden;
}

.step__form-with-button-left .v-text-field__details {
  display: none;
}

.step__form-with-button-right {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.step__form-with-button-right button {
  width: 100%;
}
/*.step__form-with-button-right button.half_height {*/
/*  height: 40%!important;*/
/*  padding: 0px!important;*/
/*}*/
/*-----------------------------------------Media-----------------------------------------*/

@media (max-width: 1390px) {
  .wrap {
    padding: 0 9rem;
  }
}

@media (max-width: 1330px) {
  .wrap {
    padding: 0 7rem;
  }
}

@media (max-width: 1250px) {
  .wrap {
    padding: 0 5rem;
  }
}

@media (max-width: 1180px) {
  .step__form {
    padding: 0 3.5rem;
  }
}

@media (max-width: 1130px) {
  .step__form {
    padding: 0 2.5rem;
  }
}

@media (max-width: 1090px) {
  .step__form {
    padding: 0 1.5rem;
  }
}

@media (max-width: 1050px) {
  .step__form {
    padding: 0 0.5rem;
  }
}

@media (max-width: 1010px) {
  .step__form {
    padding: 0;
  }
}

@media (max-width: 1000px) {
  html {
    font-size: 19px !important;
  }
  .header__empty {
    display: none;
  }
}

@media (max-width: 980px) {
  html {
    font-size: 18px !important;
  }
}

@media (max-width: 900px) {
  html {
    font-size: 17px !important;
  }
}

@media (max-width: 850px) {
  html {
    font-size: 16px !important;
  }
}

@media (max-width: 800px) {
  html {
    font-size: 15px !important;
  }
}

@media (max-width: 750px) {
  html {
    font-size: 14px !important;
  }

  .wrap {
    padding: 0 6rem;
  }

  .up {
    display: none;
  }

  .header__title-name {
    text-align: left !important;
  }
}

@media (max-width: 730px) {
  .wrap {
    padding: 0 5rem;
  }
  .header__title-logo {
    margin-right: 1rem !important;
  }
  .header__title-name {
    font-size: 1.3rem !important;
  }
  .header__button-auth {
    padding: 1rem 2rem;

    width: 8.5rem;
    height: 4rem;
  }
}

@media (max-width: 700px) {
  .wrap {
    padding: 0 4rem;
  }
}

@media (max-width: 670px) {
  .wrap {
    padding: 0 3rem;
  }
}

@media (max-width: 640px) {
  .wrap {
    padding: 0 2rem;
  }
}

@media (max-width: 620px) {
  .wrap {
    padding: 0 1rem;
  }
}

@media (max-width: 590px) {
  .step {
    padding: 3rem 2.5rem;
  }

  .step__preview {
    display: block;
  }

  .step__preview-title {
    width: 100%;
  }

  .step__preview-icon svg {
    margin: 2rem auto 0;
  }
}

@media (max-width: 570px) {
  .step {
    padding: 3rem 2rem;
  }
}

@media (max-width: 560px) {
  .step {
    padding: 3rem 1.5rem;
  }
}

@media (max-width: 540px) {
  .step {
    padding: 3rem 1rem;
  }

  .step__form-with-button-left-tooltip_hidden {
    display: none;
  }
}

@media (max-width: 540px) {
  .step__form-button {
    font-size: 1.6rem;
  }
  .step__form-invite-form {
    display: block;
  }

  .step__form-invite-form-title {
    text-align: center;
  }

  .step__form-invite-form-input input {
    font-size: 1.5rem !important;
  }

  .step__form-invite-form-copy-button {
    display: none;
  }

  .step__form-with-button {
    display: block;
  }

  .step__form-with-button .step__form-label {
    text-align: center;
  }

  .step__form-with-button-left {
    width: 100%;
  }

  .step__form-with-button-right {
    display: block;
  }

  .step__form-with-button-right button {
    width: 14rem;
  }

  .step__form-with-button-left input {
    text-align: center;
  }

  .step__form-with-button_adaptive {
    display: block !important;
  }

  .step__form-with-button_adaptive-hide {
    visibility: hidden;
  }

  .step__form-skip-button_main {
    display: none;
  }
}
</style>